import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibContainer } from '@chewy/kib-layout-react'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import styles from './SwapProductAlert.module.scss'

export interface SwapProductDialogAlertProps {
  changeType: 'product' | 'patient'
}

const SwapProductAlert = ({ changeType }: SwapProductDialogAlertProps) => {
  const { t } = useTranslation('Dialogs')

  return (
    <KibContainer className={styles.wrapper}>
      <KibTopLevelAlert
        className={styles.alert}
        heading={t('SWAP_PRODUCT_DIALOG.CHANGE_PRESCRIPTION_ALERT_TITLE', {
          changeType,
        })}
      >
        {t('SWAP_PRODUCT_DIALOG.CHANGE_PRESCRIPTION_ALERT_DETAILS')}
      </KibTopLevelAlert>
    </KibContainer>
  )
}

export default SwapProductAlert
